import { render } from "./labelDefinitions.vue?vue&type=template&id=b2593c98&scoped=true&ts=true"
import script from "./labelDefinitions.vue?vue&type=script&lang=ts"
export * from "./labelDefinitions.vue?vue&type=script&lang=ts"

import "./labelDefinitions.vue?vue&type=style&index=0&id=b2593c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2593c98"]])

export default __exports__